<template>
  <vue-form :defaults="formDefaults" @submit="submit" :editable="editable" :disabled="!editable"></vue-form>
</template>

<script>
  /**
   * defaults example: {
   *   deviceName: 'd1',
   *   deviceId: '#1',
   * }
   */
  import VueForm from '@/components/utils/vue-form'

  export default {
    data () {
      return {}
    },
    props: {
      defaults: {
        required: false,
        default: Object.create(null),
        type: Object
      },
      event: {
        required: false,
        default: 'interface',
        type: String
      },
      editable: {
        required: false,
        default: true,
        type: Boolean
      }
    },
    components: {
      VueForm
    },
    computed: {
      formDefaults () {
        return {
          parameters: [
            {
              key: 'deviceName',
              label: '设备名称',
              type: 'string'
            },
            {
              key: 'deviceId',
              label: '设备ID',
              type: 'string'
            },
            {
              key: 'interval',
              label: '上报时间间隔(秒)',
              type: 'number'
            }
          ],
          args: this.defaults
        }
      }
    },
    methods: {
      submit (data) {
        this.$emitter.emit(this.event, Object.assign({
          _id: this.defaults._id
        }, data))
        this.$emitter.once(`${this.event}Resp`, err => {
          if (!err) {
            this.editable = false
          }
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/home/forms/upload-device.vue